export default __webpack_public_path__ + "static/media/selectedLoginLogo.94e268cf.svg";